<!--  -->
<template>
  <div class="home">
    <div class="banner1">
      <div class="banner2">
        <button class="btn" @click="toYY">成为开翻译员</button>
      </div>
    </div>
    <div class="banner2"></div>
    <div class="nav">
      <ul>
        <li
          style="box-shadow: inset -1px 0px 0px 0px rgba(193, 193, 193, 0.25)"
        >
          <img class="icon" src="../assets/home/icon1.png" alt="" />
          <div style="display: inline-block; vertical-align: middle;text-align: left;">
            <a href="#a1">
            <h4>需求招募<img src="../assets/home/go.png" alt="" /></h4>
            <p>投递简历参与项目</p>
            </a>
          </div>
        </li>
        <li
          style="box-shadow: inset -1px 0px 0px 0px rgba(193, 193, 193, 0.25)"
        >
          <img class="icon" src="../assets/home/icon2.png" alt="" />
          <div style="display: inline-block; vertical-align: middle;text-align: left;">
             <a href="#a2">
            <h4>活动培训<img src="../assets/home/go.png" alt="" /></h4>
            <p>助你提升语言能力</p>
            </a>
          </div>
        </li>
        <li
          style="box-shadow: inset -1px 0px 0px 0px rgba(193, 193, 193, 0.25)"
        >
          <img class="icon" src="../assets/home/icon3.png" alt="" />
          <div style="display: inline-block; vertical-align: middle;text-align: left;">
            <a href="#a3">
            <h4>抢单任务<img src="../assets/home/go.png" alt="" /></h4>
            <p>在线抢单，零碎时间变现</p>
            </a>
          </div>
        </li>
        <li>
          <img class="icon" src="../assets/home/icon4.png" alt="" />
          <div style="display: inline-block; vertical-align: middle;text-align: left;">
            <a href="#a4">
            <h4>平台动态<img src="../assets/home/go.png" alt="" /></h4>
            <p>翻译新鲜事即可掌握</p>
            </a>
          </div>
        </li>
      </ul>
    </div>
    <div class="task">
      <div style="width: 1200px; margin: 0 auto">
        <h3
        id="a1"
          style="
            font-weight: 600;
            font-size: 24px;
            color: #2b2b2b;
            margin-bottom: 40px;
          "
        >
          需求招募
        </h3>
        <!-- <p
          style="
            font-weight: 400;
            font-size: 14px;
            color: #bdbdbd;
            margin-bottom: 32px;
          "
        >
          这是一段占位的文案文案文案文案文案文案文案文案文案
        </p> -->
        <ul
          class="flex"
          style="flex-wrap: wrap; justify-content: space-between"
        >
        <li
            v-for="item in listData"
            :key="item.kr_id"
            :class="item.kr_expedite ? 'active' : ''"
          >
            <div class="flex" style="margin-bottom:4px">
              <span class="title">{{ item.kr_name }}</span>
            </div>
            <div>
              <p class="price" v-if="item.kr_unit">
                <img class="img" src="../assets/home/price.png" alt="" />
                {{ item.kr_price_s }}-{{ item.kr_price_e }}  {{ item.kr_unit }}
              </p>
              <p class="price" v-else>面议</p>
            </div>
            <div style="margin-bottom: 16px">
              <span class="tag">{{
                item.kr_source_language == 0
                  ? "多语种"
                  : item.kr_source_language == 21
                  ? "中译外"
                  : item.kr_target_language == 21
                  ? "外译中"
                  : "外译外"
              }}</span>
              <span
                class="tag"
                v-for="(items, index) in JSON.parse(item.kr_label)"
                :key="index"
                >{{ items }}</span
              >
            </div>
            <div class="info">
              <div>
                <p class="title">项目周期</p>
                <p class="sub">{{ item.kr_cycle || "--" }}</p>
              </div>
              <div>
                <p class="title">截止时间</p>
                <p class="sub">{{ tool.formatDate(item.kr_deadline) }}</p> 
              </div>
              <div>
                <p class="title">项目领域</p>
                <p class="sub">{{ item.kr_field_name || "--" }}</p>
              </div>
              <div>
                <p class="title">语言方向</p>
                <p class="sub" v-if="item.kr_source_language == 0">多语种</p>
                <p class="sub" v-else>
                  {{ item.kr_source_language_name }}-{{
                    item.kr_target_language_name
                  }}
                </p>
              </div>
            </div>
            <button class="btn" @click="goJoin(item.kr_id)">立即参加</button>
          </li>
        </ul>
        <button class="btnGO" @click="ZMList()" >查看更多招募信息</button>
      </div>
    </div>
    <div class="news" id="a2">
      <div style="width: 1200px; margin: 0 auto">
        <h3
          style="
            font-weight: 600;
            font-size: 24px;
            color: #2b2b2b;
            margin-bottom: 40px;
          "
        >
          活动培训
        </h3>
        <!-- <p
          style="
            font-weight: 400;
            font-size: 14px;
            color: #bdbdbd;
            margin-bottom: 32px;
          "
        >
          这是一段占1111111111111111
        </p> -->
        <div class="content flex">
          <div style="width: 584px">
            <p class="title">活动报名</p>
            <img
              :src="activityInfo.at_details_picture"
              alt=""
              style="
                width: 584px;
                height: 320px;
                border-radius: 8px;
                margin-bottom: 16px;
              "
            />
            <p
              style="
                font-weight: 400;
                font-size: 14px;
                color: #597dfb;
                margin-bottom: 8px;
              "
            >
              火热招募中
            </p>
            <p
              style="
                font-weight: 500;
                font-size: 18px;
                color: #2b2b2b;
                margin-bottom: 8px;
              "
            >
              {{ activityInfo. at_name}}
            </p>
            <p
              style="
                font-weight: 400;
                font-size: 16px;
                color: #999999;
                margin-bottom: 16px;
              "
            >
              无论您是希望拓宽职业道路的毕业生；还是已经从事翻译、本地化服务等行业的专业人士；本次课程都将为您提供一个全面升级、跨越发展的平台。
            </p>
            <button class="btnNews" @click="toMoveAbout(activityInfo.atid)">
              &nbsp;&nbsp;&nbsp;&nbsp;点击立即报名
            </button>
          </div>
          <div style="width: 584px">
            <p class="title">培训专区</p>
            <img
              @click="toArticleInfo(artHost[0].alid, artHost[0].al_outside)"
              :src="artHost[0].al_push_ph"
              alt=""
              style="
                cursor: pointer;
                width: 584px;
                height: 320px;
                border-radius: 8px;
                margin-bottom: 16px;
              "
            />
            <p
              style="
                font-weight: 400;
                font-size: 14px;
                color: #597dfb;
                margin-bottom: 8px;
              "
            >
              筹备中
            </p>
            <p
              style="
                font-weight: 500;
                font-size: 18px;
                color: #2b2b2b;
                margin-bottom: 8px;
              "
            >
              {{ artHost[0].al_l_title}}
            </p>
            <p
              style="
                font-weight: 400;
                font-size: 16px;
                color: #999999;
                margin-bottom: 16px;
              "
            >
              {{ artHost[0].al_abstract}}
            </p>
            <button class="btnNews" @click="toArticleInfo(artHost[0].alid, artHost[0].al_outside)">
              &nbsp;&nbsp;&nbsp;&nbsp;点击立即查看
            </button>
          </div>
          <!-- <div style="width: 584px">
            <p class="title">活动专区</p>
            <div style="margin-bottom: 4px">
              <div class="flex" style="justify-content: space-between;cursor: pointer;">
                <img
                  src="../assets/home/page1.png"
                  alt=""
                  style="width: 276px; height: 136px; border-radius: 8px"
                />
                <div style="width: 276px; margin-bottom: 16px">
                  <p
                    style="
                      font-weight: 500;
                      font-size: 18px;
                      color: #2b2b2b;
                      margin-bottom: 8px;
                    "
                  >
                    大卫·弗格森：译者应该发挥...
                  </p>
                  <p
                    style="
                      font-weight: 400;
                      font-size: 16px;
                      color: #999999;
                      margin-bottom: 8px;
                      line-height: 24px;
                    "
                  >
                    大卫·弗格森（David Ferguson），职业作家、译审、英文编辑、媒体人，中国外文局高级编审，曾是中国网...
                  </p>
                  <p
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      color: #597dfb;
                      line-height: 22px;
                    "
                  >
                    11-23 至 11-23
                  </p>
                </div>
              </div>
              <div class="flex" style="justify-content: space-between;cursor: pointer;">
                <img
                  src="../assets/home/page2.png"
                  alt=""
                  style="width: 276px; height: 136px; border-radius: 8px"
                />
                <div style="width: 276px; margin-bottom: 16px">
                  <p
                    style="
                      font-weight: 500;
                      font-size: 18px;
                      color: #2b2b2b;
                      margin-bottom: 8px;
                    "
                  >
                    “海外翻译与传播应用能力培养...
                  </p>
                  <p
                    style="
                      font-weight: 400;
                      font-size: 16px;
                      color: #999999;
                      margin-bottom: 8px;
                      line-height: 24px;
                    "
                  >
                    由中国翻译研究院主办，北京中外翻译咨询有限公司承办的"海外翻译与传播应用能力培养计划"第一期学习交流...
                  </p>
                  <p
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      color: #597dfb;
                      line-height: 22px;
                    "
                  >
                    03-29 至 03-31
                  </p>
                </div>
              </div>
              <div class="flex" style="justify-content: space-between;cursor: pointer;">
                <img
                  src="../assets/home/page3.png"
                  alt=""
                  style="width: 276px; height: 136px; border-radius: 8px"
                />
                <div style="width: 276px; margin-bottom: 16px">
                  <p
                    style="
                      font-weight:500;
                      font-size: 18px;
                      color: #2b2b2b;
                      margin-bottom: 8px;
                    "
                  >
                    “海外翻译与传播应用能力培养...
                  </p>
                  <p
                    style="
                      font-weight: 400;
                      font-size: 16px;
                      color: #999999;
                      margin-bottom: 8px;
                      line-height: 24px;
                    "
                  >
                    由中国翻译研究院主办，北京中外翻译咨询有限公司承办的“海外翻译与传播应用能力培养计划”第一期学习交流...
                  </p>
                  <p
                  id="a3"
                    style="
                      font-weight: 400;
                      font-size: 14px;
                      color: #597dfb;
                      line-height: 22px;
                    "
                  >
                    11-30 至 11-30
                  </p>
                </div>
              </div>
            </div>
            <button class="btnMore" @click="toCMS()">点击了解更多</button>
          </div> -->
        </div>
      </div>
    </div>
    <div class="banner3"  id="a4">
      <div class="banner4" >
        <p
          style="
            position: absolute;
            top: 70px;
            left: 487px;
            font-size: 16px;
            color: #2b2b2b;
            width: 530px;
          "
        >
         海量在线翻译任务等你来抢！</br>
内容短平，沟通少，零碎时间也能挣钱！
        </p>
        <button class="btn" @click="toRecruit()">进入抢单任务大厅</button> 
      </div>
    </div>
    <div class="dynamics" >
      <div style="width: 1200px; margin: 0 auto">
        <h3
       
          style="
            font-weight: 600;
            font-size: 24px;
            color: #2b2b2b;
            margin-bottom: 40px;
          "
        >
          平台动态
        </h3>
        <!-- <p
          style="
            font-weight: 400;
            font-size: 14px;
            color: #bdbdbd;
            margin-bottom: 32px;
          "
        >
          这是一段占位的文案文案文案文案文案文案文案文案文案
        </p> -->
        <ul class="flex" style="justify-content: space-between">
          <li style="width: 276px;cursor: pointer;" v-for="item in columnData" @click="toArticleInfo(item.alid, item.al_outside)" :key="item.alid">
             <div class="box" :style="`background-image:url('${item.al_cover}')`"></div>
            <p
              style="
                font-weight: 400;
                font-size: 14px;
                color: #597dfb;
                margin-bottom: 8px;
              "
            >
              {{ tool.formatDate(item.al_release_time) }}
            </p>
            <p
              style="
                font-weight: 500;
                font-size: 18px;
                color: #2b2b2b;
                margin-bottom: 8px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 270px;
              "
            >
              {{ item.al_l_title }}
            </p>
            <p style="
            font-weight:400;
            height:45px; 
            font-size: 16px; 
            color: #999999;max-width: 270px; 
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 270px;
            "
            >
              {{ item.al_abstract}}
            </p>
          </li>
          <!-- <li style="width: 276px">
            <div class="box"></div>
            <p
              style="
                font-weight: 400;
                font-size: 14px;
                color: #597dfb;
                margin-bottom: 8px;
              "
            >
              2025-05-05
            </p>
            <p
              style="
                font-weight: 500;
                font-size: 18px;
                color: #2b2b2b;
                margin-bottom: 8px;
              "
            >
              这是一段占位标题这是一段占位标
            </p>
            <p style="font-weight: 400; font-size: 16px; color: #999999">
              这是一段占位文案这是一段占位文案这是一段占位文案这是一段占位文案这是
            </p>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="foot">
      <div style="width: 1200px; margin: 0 auto">
        <h4
          style="
            font-weight: 600;
            font-size: 24px;
            color: #2b2b2b;
            text-align: center;
            margin-bottom: 24px;
            margin-top: 98px;
          "
        >
          值得选择的翻译平台
        </h4>
        <ul class="flex" style="justify-content: space-between;margin-bottom:24px;">
          <li class="box1 box">
            <p class="txt1">任务众多</p>
            <p class="txt2">20余种语言类</br>非语言类任务类型</br>年任务量超5亿字/词</p>
          </li>
          <li class="box2 box"> <p class="txt1">随时抢单</p>
            <p class="txt2">不受时间地点限制</br>随时领取翻译任务</br>工作更加灵活自由</p></li>
          <li class="box3 box"> <p class="txt1">玩法友好</p>
            <p class="txt2">平台翻译等级细分</br>每个译员都能轻松</br>找到符合自己能力的定级</p></li>
          <li class="box4 box"> <p class="txt1">涨钱快速</p>
            <p class="txt2">完成翻译任务</br>获得好评即可升级</br>通过升级提高任务价格</p></li>
        </ul>
        <button class="btn" @click="toYY">成为开翻译员</button>
      </div>
    </div>
  </div>
</template>

<script>
import { API_1, Adm, Public, task } from "@/conf/api";
import tool from "@/tool/tool";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      listData: [],
      tool: tool,
      activityInfo: {},
      columnData: {},
      artHost: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toArticleInfo(id, outside) {
      if (outside) {
        window.open(outside, "_blank");
        this.$axios
          .get(`${this.$RealUrl.realUrl}/get_article?alid=${id}`)
          .then((res) => {})
          .catch((err) => {});
        return false;
      }
      if (id) {
        let routeUrl = this.$router.resolve({ path: `/realInfo/${id}` });
        window.open(routeUrl.href, "_blank");
      }
    },
    toYY() {
      this.$router.push("/userBio");
    },
    toRecruit() {
      this.$router.push("/taskHall");
    },
    toArticleInfo(id, outside) {
      if (outside) {
        window.open(outside, "_blank");
        this.$http
          .get(`${this.$RealUrl.realUrl}/get_article?alid=${id}`)
          .then((res) => {})
          .catch((err) => {});
        return false;
      }
      let routeUrl = this.$router.resolve({ path: `/realInfo/${id}` });
      window.open(routeUrl.href, "_blank");
    },
    getArtHost() {
      this.$axios
        .get(`${this.$RealUrl.realUrl}/get_article_host`)
        .then((res) => {
          let _data = res.data;
          // console.log(_data, '获取热门文章');
          if (res.data.status) {
            if (_data.data) this.artHost = _data.data.slice(-5);
          } else {
            this.$message.err("获取热门文章失败！");
          }
        })
        .catch((res) => {});

      // this.$axios
      //   .get(`${this.$RealUrl.realUrl}/get_article_host`)
      //   .then((res) => {
      //     let _data = res.data;
      //     // console.log(_data, '获取热门文章');
      //     if (res.data.status) {
      //       if (_data.data) this.artHost = _data.data.slice(-5);
      //     } else {
      //       this.$message.err("获取热门文章失败！");
      //     }
      //   });
    },
    getHtml() {
      // this.$axios
      //   .get(`${this.$RealUrl.realUrl}/get_index_enum?eid=18`)
      //   .then((res) => {
      //     let _this = this;
      //     let _data = res.data.data;
      //     // console.log(_data);
      //     this.banner = "";
      //     this.banner = _data.cename;
      //     // this.$nextTick(() => {
      //     //   $(".hmTop .banner_item, .hmTop .hmt_push li").click(function () {
      //     //     let _path = $(this).attr("data-path");
      //     //     if (_path) {
      //     //       let routeUrl = _this.$router.resolve({ path: _path });
      //     //       window.open(routeUrl.href, "_blank");
      //     //     }
      //     //   });
      //     // });
      //   });
      this.$axios
        .get(
          `${this.$RealUrl.realUrl}/article_list?page=${1}&sum=${4}&column=${0}`
        )
        .then((res) => {
          let _data = res.data.data;
          // console.log(_data, '获取栏目内的列表信息');
          if (res.data.status) {
            this.columnData = _data.list;
          } else {
            this.$message.err("获取栏目内数据失败！");
          }
        });
      // this.$axios
      //   .get(`${this.$RealUrl.realUrl}/get_index_enum?eid=19`)
      //   .then((res) => {
      //     let _this = this;
      //     let _data = res.data.data;
      //     // console.log(_data);
      //     this.special = _data.cename;
      //     // this.$nextTick(() => {
      //     //   $(".item_spe_img, .item_special h4").click(function () {
      //     //     let _id = $(this).attr("data-id");
      //     //     if (_id) {
      //     //       _this.toTopicDoc(_id);
      //     //     }
      //     //   });
      //     // });
      //   });

      this.$axios.get(`${this.$RealUrl.realUrl}/activity_hot`).then((res) => {
        this.activityInfo = res.data.data[0];
        let _this = this;
        let _data = res.data.data;
        // console.log(_data);
        this.activityData = _data || [];
        // this.activityData.map((item) => {
        //   item.class = this.countDown(
        //     item.at_start_register,
        //     item.at_end_register
        //   );
        // });
      });

      // this.$axios
      //   .get(`${this.$RealUrl.realUrl}/get_index_enum?eid=21`)
      //   .then((res) => {
      //     let _this = this;
      //     let _data = res.data.data;
      //     // console.log(_data);
      //     this.advertisement = _data.cename;
      //   });
    },
    toMoveAbout(id) {
      let routeUrl = this.$router.resolve({ path: `/moveAbout/${id}` });
      window.open(routeUrl.href, "_blank");
    },
    goJoin(id) {
      this.$router.push({
        path: "/recruitDetail",
        query: {
          nu: id,
        },
      });
    },
    getList() {
      let params = {
        page: 1,
        sum: 8,
      };
      this.$axios
        .get(API_1 + Public.getRecruitList, {
          params: params,
        })
        .then((res) => {
          if (res.data.status) {
            this.listData = res.data.data.list;
          } else {
            let msg = eval("'" + res.data.message + "'");
            this.$message({
              message: decodeURIComponent(msg),
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    ZMList() {
      this.$router.push("/recruitList");
    },
    toCMS() {
      this.$router.push("/category");
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
    this.getHtml();
    this.getArtHost();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
* {
  font-family: PingFang SC, PingFang SC;
}
.home {
  min-width: 1200px;
  background: #fff;
  .flex {
    display: flex;
    justify-content: space-between;
  }
  .banner1 {
    height: 500px;
    width: 100%;
    background: url(../assets/home/banner1.png) no-repeat center center;
    background-size: cover;
    .banner2 {
      width: 1200px;
      height: 500px;
      background: url(../assets/home/banner2.png) no-repeat center center;
      background-size: 1200px 500px;
      margin: 0 auto;
      position: relative;
      .btn {
        position: absolute;
        bottom: 65px;
        left: 0;
        width: 276px;
        height: 40px;
        background: linear-gradient(90deg, #6bdeff 0%, #5afb9a 100%);
        border-radius: 20px 20px 20px 20px;
        color: #303030;
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
        &:hover {
          background: linear-gradient(90deg, #a3ebff 0%, #a5ffc9 100%);
        }
      }
    }
  }
  .nav {
    height: 96px;
    width: 100%;
    background: #fff;
    color: #2b2b2b;
    ul {
      margin: 0 auto;
      width: 1200px;
      display: flex;
      height: 96px;
      align-items: center;

      li {
        cursor: pointer;
        width: 300px;
        text-align: center;
        a {
          color: #2b2b2b;
        }
        .icon {
          width: 56px;
          height: 56px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 16px;
        }
        h4 {
          font-weight: 600;
          font-size: 16px;
          margin-bottom: 8px;

          img {
            margin-left: 8px;
            width: 24px;
            height: 14px;
            vertical-align: baseline;
          }
        }
        p {
          font-weight: 500;
          font-size: 12px;
          color: #8c8d9e;
        }
      }
    }
  }
  .task {
    background: url(../assets/home/bg.png) no-repeat center center;
    background-size: cover;
    width: 100%;
    height: 808px;
    padding-top: 40px;
    padding-bottom: 36px;
    margin-bottom: 40px;
    .btnGO {
      width: 176px;
      height: 40px;
      border-radius: 3px 3px 3px 3px;
      color: #fff;
      margin: 0 auto;
      display: block;
      background: #675dfb;
      position: relative;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      &:hover {
        background: #5d77fb;
      }
      &::before {
        content: "";
        position: absolute;
        top: -10px;
        right: -16px;
        width: 28px; /* 伪元素尺寸大于父容器 */
        height: 26px;
        background-image: url(../assets/home/go2.png);
        background-size: 28px 26px;
        z-index: 8; /* 防止遮盖内容 */
      }
    }
    ul {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .active {
        background: url(../assets/recruit/jj.png) no-repeat top right;
        background-size: 64px 28px;
        background-color: #fff;
      }
      li {
        margin-bottom: 32px;
        width: 276px;
        height: 302px;
        background: #fff;
        border-radius: 16px 16px 16px 16px;
        padding: 24px;
        box-sizing: border-box;
        .info {
          // margin-bottom: 4px;
          div {
            display: inline-block;
            width: 114px;
            // height: 37px;
            box-sizing: border-box;
            // margin-bottom: 8px;
            .title {
              font-weight: 400;
              font-size: 12px;
              color: #bdbdbd;
              margin-bottom: 4px;
              height: 22px;
              line-height: 22px;
            }
            .sub {
              font-weight: 400;
              font-size: 12px;
              height: 22px;
              color: #2b2b2b;
              line-height: 22px;
              margin-bottom: 8px;
            }
          }
        }
        .title {
          font-weight: 600;
          font-size: 18px;
          color: #2b2b2b;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 220px;
        }
        .price {
          .img {
            width: 12px;
            height: 14px;
            display: inline-block;
            vertical-align: baseline;
          }
          font-weight: 600;
          font-size: 18px;
          background: linear-gradient(180deg, #ff9500 0%, #ff4922 50%);
          text-align: left;
          margin-bottom: 4px;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .tag {
          // width: 44px;
          height: 20px;
          line-height: 20px;
          background: #eff3ff;
          border-radius: 3px 3px 3px 3px;
          font-weight: 400;
          font-size: 12px;
          color: #366ef4;
          margin-right: 4px;
          display: inline-block;
          text-align: center;
          vertical-align: middle;
          padding: 0 4px;
          &:last-child {
            margin-right: 0;
          }
        }
        .btn {
          width: 228px;
          height: 32px;
          line-height: 32px;
          background: linear-gradient(90deg, #58d7fb 0%, #675afb 100%);
          border-radius: 16px 16px 16px 16px;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          cursor: pointer;
          margin-top: 8px;
          &:hover {
            background: linear-gradient(90deg, #8fe6ff 0%, #8b80ff 100%);
          }
        }
      }
    }
  }
  .news {
    background: #fff;
    margin-bottom: 40px;
    .title {
      font-weight: 600;
      font-size: 18px;
      color: #2b2b2b;
      border-left: 4px solid #597dfb;
      padding-left: 4px;
      margin-bottom: 16px;
    }
    .btnMore {
      float: right;
      width: 144px;
      height: 40px;
      line-height: 40px;
      background: #675dfb;
      border-radius: 3px 3px 3px 3px;
      color: #fff;
      cursor: pointer;
      font-weight: 400;
      font-size: 14px;
      &:hover {
        background: #5d77fb;
      }
    }
    .btnNews {
      width: 174px;
      height: 40px;
      line-height: 40px;
      background-image: linear-gradient(90deg, #ffbb01 0%, #fb5d60 100%);
      border-radius: 3px 3px 3px 3px;
      color: #fff;
      position: relative;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      &:hover {
        background: linear-gradient(90deg, #ffed69 0%, #ff6c47 100%);
      }
      &::before {
        content: "";
        position: absolute;
        top: 12px;
        left: 24px;
        width: 18px; /* 伪元素尺寸大于父容器 */
        height: 18px;
        background-image: url(../assets/home/fire.png);
        background-size: 18px 18px;
        z-index: 1; /* 防止遮盖内容 */
      }
    }
  }
  .banner3 {
    height: 230px;
    width: 100%;
    background: url(../assets/home/bgline.png) no-repeat center center;
    background-size: cover;
    margin-bottom: 40px;
    .banner4 {
      width: 1200px;
      height: 230px;
      background: url(../assets/home/banner3.png) no-repeat center center;
      background-size: 1200px 230px;
      margin: 0 auto;
      position: relative;
      .btn {
        position: absolute;
        bottom: 48px;
        left: 487px;
        width: 177px;
        height: 40px;
        line-height: 40px;
        border-radius: 3px 3px 3px 3px;
        background: #675dfb;
        border-radius: 3px 3px 3px 3px;
        color: #fff;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        &:hover {
          background: #5d77fb;
        }
        &::before {
          content: "";
          position: absolute;
          bottom: -15px;
          right: -25px;
          width: 48px; /* 伪元素尺寸大于父容器 */
          height: 48px;
          background-image: url(../assets/home/hand.png);
          background-size: 48px 48px;
          z-index: 8; /* 防止遮盖内容 */
        }
      }
    }
  }
  .dynamics {
    margin-bottom: 40px;
    .box {
      background: url(../assets/home/zw1.png) no-repeat center center;
      width: 276px;
      height: 200px;
      border-radius: 16px;
      margin-bottom: 16px;
      position: relative;
      background-size: cover;
      &::before {
        content: "最新动态";
        position: absolute;
        bottom: 0px;
        left: 0px;
        width: 92px; /* 伪元素尺寸大于父容器 */
        height: 32px;
        background-image: url(../assets/home/bottom.png);
        background-size: 92px 32px;
        z-index: 8; /* 防止遮盖内容 */
        color: #fff;
        font-weight: 400;
        font-size: 14px;
        text-align: center;
        vertical-align: middle;
        line-height: 32px;
      }
    }
  }
  .foot {
    background: url(../assets/home/bgF.png) no-repeat center center;
    background-size: cover;
    width: 100%;
    height: 530px;
    text-align: center;
    box-sizing: border-box;
    .btn {
      width: 144px;
      height: 40px;
      line-height: 40px;
      background: #675dfb;
      border-radius: 3px 3px 3px 3px;
      color: #ffffff;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      &:hover {
        background: #5d77fb;
      }
    }
    .box {
      width: 276px;
      height: 294px;
      padding-top: 156px;
      text-align: center;
      box-sizing: border-box;
      .txt1 {
        font-weight: 600;
        font-size: 18px;
        color: #2b2b2b;
        margin-bottom: 8px;
      }
      .txt2 {
        font-weight: 400;
        font-size: 16px;
        color: #999999;
        width: 212px;
        height: 72px;
        margin: 0 auto;
      }
    }
    .box1 {
      background: url(../assets/home/foot1.png) no-repeat center center;
      background-size: 276px 294px;
    }
    .box2 {
      background: url(../assets/home/foot2.png) no-repeat center center;
      background-size: 276px 294px;
    }
    .box3 {
      background: url(../assets/home/foot3.png) no-repeat center center;
      background-size: 276px 294px;
    }
    .box4 {
      background: url(../assets/home/foot4.png) no-repeat center center;
      background-size: 276px 294px;
    }
  }
}
</style>